<template>
  <app-admin>
    <div class="container content clearfix">
      <h1>Редактирование программы</h1>
      <loader ref="loader"/>
      <div v-if="test">
        <div class="form-group">
          <span class="label">Название</span>
          <SmartInput v-model="test.name" @change="onTestChange"></SmartInput>
        </div>

        <div class="form-group" style="align-items: flex-start">
          <span class="label">Описание</span>
          <SmartInput v-model="test.description" @change="onTestChange" :textarea="true"></SmartInput>
        </div>

        <div class="form-group">
          <span class="label">Макс. балл</span>
          <div class="w-100">
            <SmartInput v-model="test.score" @change="onTestChange"></SmartInput>
          </div>
        </div>

        <div class="form-group">
          <span class="label">Время прохождения</span>
          <div class="w-100">
            <SmartInput v-model="test.time" @change="onTestChange"></SmartInput>
          </div>
          <span>мин.</span>
        </div>

        <div class="form-group">
          <span class="label">Первый вопрос</span>
          <select v-model="test.start_question" @change="onTestChange">
            <option value="" disabled>Выберите вопрос, с которого будет начинаться тест</option>
            <option :key="question.id" :value="question.id" v-for="question in testQuestions">{{question.id}} <span v-html="parseText(question.text)"></span>
            </option>
          </select>
        </div>

        <div class="form-group">
          <span class="label">Компетенции</span>
          <table class="table points">
            <thead>
            <tr>
              <th class="name">Название</th>
              <th class="index">Кол-во баллов</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="point in test.points" :key="point.name">
              <td>
                <SmartInput v-model="point.name" @change="onTestChange"></SmartInput>
              </td>
              <td>
                <SmartInput v-model="point.value" @change="onTestChange"></SmartInput>
              </td>
              <td class="points__remove" @click="removePoint(point)">
                <font-awesome-icon icon="times"/>
              </td>
            </tr>
            <tr class="new-point">
              <td class="new-point__text">
                <SmartInput v-model="newPointKey" @change="createNewPoint"
                            placeholder="Нажмите, чтобы добавить" ref="newPointInput"></SmartInput>
              </td>
              <td></td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="answers-line">
          <h1>Вопросы</h1>
          <div class="btn question__btn" @click="showQuestionModal">
            <font-awesome-icon icon="plus"/>
            Добавить вопрос
          </div>
          <div class="tools" v-show="test.test_questions.length">
            <span @click="showAll">Раскрыть все</span>
            <span @click="hideAll">Скрыть все</span>
          </div>
        </div>
        <div>
          <div v-for="(question, index) in test.test_questions" :key="question.id" v-if="index<itemsCount">
            <TestQuestion :question="question" ref="question"/>
          </div>
        </div>
        <div class="text-center">
          <span style="display: none">{{itemsCount}}, {{testQuestions.length }}</span>
          <div class="btn btn-light btn-more" :class="{progress: busy}" @click="loadMore" v-if="itemsCount < this.testQuestions.length">Показать еще</div>
          <div class="btn question__btn" @click="showQuestionModal" v-show="test.test_questions.length > 2">
            <font-awesome-icon icon="plus"/>
            Добавить вопрос
          </div>
        </div>
      </div>
      <transition name="fade">
        <NewQuestionModal @cancel="showModal=false" v-if="showModal" @createQuestion="createQuestion"/>
      </transition>
    </div>
  </app-admin>
</template>

<script>
  import TestsService from '@/services/TestsService'
  import QuestionsService from '@/services/QuestionsService'
  import SmartInput from '@/components/SmartInput'
  import TestQuestion from '@/components/tests/TestQuestion'
  import NewQuestionModal from '@/components/modal/NewQuestionModal'
  import { mapGetters } from 'vuex'

  export default {
    name: 'edit-test',
    components: {
      SmartInput,
      TestQuestion,
      NewQuestionModal
    },
    data () {
      return {
        showModal: false,
        newPointKey: '',
        perPage: 10,
        itemsCount: 10,
        busy: false
      }
    },
    computed: {
      ...mapGetters(['test']),

      testQuestions () {
        return this.$store.getters.test.test_questions
      }
    },
    methods: {
      parseText (text) {
        return this.$options.filters.ellipsis(text, 100)
      },

      onTestChange () {
        TestsService.patchTest(this.test).then(
          (response) => {
          }
        )
      },
      loadMore () {
        this.busy = true
        if (this.itemsCount < this.testQuestions.length) {
          this.itemsCount += this.perPage
          if (this.itemsCount >= this.testQuestions.length) {
            this.itemsCount = this.testQuestions.length
          }
        }
        this.busy = false
      },
      showAll () {
        for (const index in this.$refs.question) {
          this.$refs.question[index].show()
        }
      },
      hideAll () {
        for (const index in this.$refs.question) {
          this.$refs.question[index].hide()
        }
      },
      showQuestionModal () {
        this.showModal = true
      },
      createQuestion (question) {
        QuestionsService.createQuestion(this.$store.getters.test.id, question).then(
          (response) => {
            this.$store.dispatch('addQuestion', response).then(
              () => {
                this.showModal = false
                window.scrollTo(0, document.body.scrollHeight)
              }
            )
          }
        )
      },
      createNewPoint (name) {
        this.$store.dispatch('setTestPoint', {name, value: 0})
        this.newPointKey = ''
        this.$refs.newPointInput.clear()
        this.onTestChange()
      },
      removePoint (point) {
        this.$store.dispatch('deletePoint', point)
        this.onTestChange()
      }
    },
    mounted () {
      let id = this.$route.params.id
      let slug = this.$store.getters.slug
      this.$refs.loader.show()

      TestsService.getTest(slug, id).then(
        (response) => {
          this.$refs.loader.hide()
          this.$store.dispatch('setTest', response)
        }
      )
    }
  }
</script>

<style scoped lang="scss">
  .w-100 {
    width: 100px;
  }

  .label {
    margin-right: 20px;
    font-weight: bold;
    width: 15%;
  }

  .form-group {
    justify-content: flex-start;
    margin-bottom: 2em;
    select {
      max-width: 60%;
      padding: 7px;
    }
  }

  .points {
    width: 60%;
    th, td {
      padding: 3px 10px;
    }
    th {
      font-weight: 400;
      border-bottom: 1px solid $light-blue;
      color: $blue;
    }
    text-align: left;
    .name {
      width: 400px;
    }
    &__remove {
      min-width: 50px;
      text-align: center;
      cursor: pointer;

      path {
        fill: #a6b5d1;
      }
      &:hover path {
        fill: $blue
      }
    }
    .new-point {
      &__text {
        input {
          width: 100%;
        }
      }
      &__number {

      }
    }
  }

  .answers-line {
    margin: 80px 0 20px 0;
    .tools {
      text-align: right;
      color: #8c8c8c;
      font-weight: 300;
      span {
        display: inline-block;
        margin-left: 20px;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .btn-more {
    margin-right: 50px;
    &.progress {
      background-image: repeating-linear-gradient(-45deg, rgba(177, 200, 227, 0.2), rgba(177, 200, 227, 0.2) 1rem, transparent 1rem, transparent 2rem);
      background-size: 10000% 200%;
      will-change: backgroud-position;
      animation: progress 1200s linear infinite;
    }
  }

  @keyframes progress {
    0% {
      background-position: 100% 50%;
    }
    100% {
      background-position: -100% 50%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/tests/EditTest.vue